import { NAME } from './constants';

export const INIT_DRIVERS = `${NAME}/INIT_DRIVERS`;
export const INIT_SHIPPERS = `${NAME}/INIT_SHIPPERS`;
export const INIT_SHIPMENTS = `${NAME}/INIT_SHIPMENTS`;
export const CONNECT_RELATIONS = `${NAME}/CONNECT_RELATIONS`;

export const FETCH_DRIVER_DOCS = `${NAME}/FETCH_DRIVER_DOCS`;
export const DRIVER_DOCS_FETCHED = `${NAME}/DRIVER_DOCS_FETCHED`;

export const APPROVE_DRIVER_DOC = `${NAME}/APPROVE_DRIVER_DOC`;
export const DRIVER_DOC_APPROVED = `${NAME}/DRIVER_DOC_APPROVED`;
export const REJECT_DRIVER_DOC = `${NAME}/REJECT_DRIVER_DOC`;
export const DRIVER_DOC_REJECTED = `${NAME}/DRIVER_DOC_REJECTED`;

export const ASSIGN_REFERENCE_ID = `${NAME}/ASSIGN_REFERENCE_ID`;

export const ASSIGNED_REFERENCE_ID = `${NAME}/ASSIGNED_REFERENCE_ID`;
